import React, { forwardRef } from 'react';
import type { View as RNView } from 'react-native';
import { Menu } from '@/components/gluestack/menu';
import { ButtonWrapper } from '@/components/ui/ButtonWrapper';
import { useIsLargeScreen } from '@/hooks/useIsLargeScreen';
import { MoreVerticalIcon } from '@hugeicons-pro/core-solid-rounded';

export interface IContextMenuProps {
  children: React.ReactNode;
  placement?: React.ComponentProps<typeof Menu>['placement'];
  offset?: number;
  icon?: any;
  iconSize?: number;
}

const ContextMenu = forwardRef<RNView, IContextMenuProps>((props, _ref) => {
  const { children, placement = 'bottom right', offset = 8, icon = MoreVerticalIcon, iconSize } = props;
  const isLargeScreen = useIsLargeScreen();

  return (
    <Menu
      placement={placement}
      offset={offset}
      trigger={(triggerProps: any) => (
        !isLargeScreen ? (
          <ButtonWrapper
            {...triggerProps}
            size="sm"
            icon={icon}
            iconSize={iconSize ?? 20}
            inAppHeaderBar
            hitSlop={{ top: 10, bottom: 10, left: 10, right: 10 }}
          />
        ) : (
          <ButtonWrapper
            {...triggerProps}
            variant="solid"
            action="neutral"
            size="sm"
            icon={icon}
            iconSize={iconSize ?? 24}
            preventFocusOnMouseDown
          />
        )
      )}>
      {children}
    </Menu>
  );
});

export default ContextMenu;


